import { render, staticRenderFns } from "./SaveSearchSelector.vue?vue&type=template&id=3bdf4fcf&scoped=true&lang=pug"
import script from "./SaveSearchSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveSearchSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SaveSearchSelector.vue?vue&type=style&index=0&id=3bdf4fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf4fcf",
  null
  
)

export default component.exports